import { ChangeEvent, FormEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from '../../../ui/toast';
import { adminLogin } from '../../../utils/api_service/admin';

export interface IUseAdminLogin {
  username: string;
  password: string;
  handleUsernameChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handlePasswordChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: FormEvent) => Promise<void>;
}

export const useAdminLogin = (): IUseAdminLogin => {
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const history = useHistory();

  const handleUsernameChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    try {
      const res = await adminLogin({ username, password });

      if (res.ok) {
        const result = await res.json();
        localStorage.setItem('adminToken', result.access_token);
        history.push('/organizations');
      } else {
        toast.error('Invalid login', { position: 'bottom-center' });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return {
    username,
    password,
    handleUsernameChange,
    handlePasswordChange,
    handleSubmit,
  };
};
